<template>
  <templateAdminComponent v-if="isUserAuthenticated()">
    <div>
      <v-toolbar flat color="white">
        <v-toolbar-title>Clients</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
            <v-btn slot="activator" color="primary" dark class="mb-2" @click="createItem()">Nouveau client</v-btn>
            <v-card>
              <v-card-title style="padding-bottom:0px;">
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text style="padding-top:0px;padding-bottom:0px;">
                <v-form v-model="valid" ref="form" lazy-validation>
                <v-container fluid grid-list-md>
                  <v-layout row wrap>
                    <v-flex xs9 sm9 md9>
                      <v-text-field v-model="editedItem.Customer.Name" label="Nom" autocomplete="editedItem.Customer.Name" hide-details :rules="nameRules" required></v-text-field>
                    </v-flex>
                    <v-flex xs3 sm3 md3>
                      <v-checkbox v-model="editedItem.Customer.IsActive" label="Est actif" hide-details></v-checkbox>
                    </v-flex>
                    <v-flex xs6 sm6 md6>
                      <v-text-field v-model="editedItem.Customer.PhoneNumber" label="# Tél." autocomplete="editedItem.Customer.PhoneNumber" maxlength="10" return-masked-value mask="(###) ###-####" hide-details></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm6 md6>
                      <v-text-field v-model="editedItem.Customer.CellNumber" label="# Cell." autocomplete="editedItem.Customer.CellNumber" maxlength="10" return-masked-value mask="(###) ###-####" hide-details></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-text-field v-model="editedItem.Customer.Email" label="Courriel" autocomplete="editedItem.Customer.Email" hide-details></v-text-field>
                    </v-flex>
                    <!-- <v-flex v-for="item in editedItem.Customer.CustomerNoteTypes" v-bind:key="item.ID">
                      <v-checkbox v-model="item.IsActive" :label="item.NoteType.Name" style="margin-top:10px;" hide-details></v-checkbox>
                    </v-flex> -->
                    <v-flex xs12 sm12 md12>
                      <v-textarea v-model="editedItem.Customer.Note" label="Note" rows="2" autocomplete="editedItem.Customer.Note" style="padding-top:0px;" hide-details></v-textarea>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-textarea v-model="editedItem.Customer.PrivateNote" label="Note privée" rows="2" autocomplete="editedItem.Customer.PrivateNote" hide-details></v-textarea>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-textarea v-model="editedItem.Customer.PoleNote" label="Note poteau" rows="2" autocomplete="editedItem.Customer.PoleNote" hide-details></v-textarea>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-layout row wrap>
                        <v-flex d-flex xs6 sm6 md6>
                          <v-card>
                            <v-card-title style="padding:0px;">
                              <h5>Adresse de déneigement</h5>
                            </v-card-title>
                            <v-card-text style="padding:0px;">
                              <v-container fluid grid-list-md style="padding:0px;">
                                <v-layout row wrap>
                                  <v-flex xs6 sm6 md6>
                                    <v-text-field v-model="editedItem.Customer.AddressSnowRemoval.DoorNumber" label="Numéro porte" autocomplete="editedItem.Customer.AddressSnowRemoval.DoorNumber" @blur="CopyDoorNumber()" hide-details :rules="requiredRules" required></v-text-field>
                                  </v-flex>
                                  <v-flex xs6 sm6 md6>
                                    <v-text-field v-model="editedItem.Customer.AddressSnowRemoval.Address" label="Adresse" autocomplete="editedItem.Customer.AddressSnowRemoval.Address" hide-details :rules="requiredRules" required></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm12 md12>
                                    <!-- <v-text-field v-model="editedItem.AddressSnowRemoval.Street.Name" label="Rue" hide-details></v-text-field> -->
                                    <v-autocomplete
                                      :items="streetitems"
                                      :search-input.sync="streetName"
                                      :menu-props="{maxHeight:'250px'}"
                                      v-model="editedItem.Customer.AddressSnowRemoval.StreetID"
                                      item-text="Name"
                                      item-value="ID"
                                      label="Rue"
                                      @blur="CopyStreet()"
                                      autocomplete="editedItem.Customer.AddressSnowRemoval.StreetID"
                                      hide-details
                                      :rules="requiredRules"
                                      required
                                    >
                                    </v-autocomplete>
                                  </v-flex>
                                  <v-flex xs12 sm12 md12>
                                    <!-- <v-text-field v-model="editedItem.AddressSnowRemoval.Town.Name" label="Ville" hide-details></v-text-field> -->
                                    <!-- {{editedItem.AddressSnowRemoval.TownID}} -->
                                    <v-autocomplete
                                      :items="townitems"
                                      :search-input.sync="townName"
                                      :menu-props="{maxHeight:'250px'}"
                                      v-model="editedItem.Customer.AddressSnowRemoval.TownID"
                                      item-text="Name"
                                      item-value="ID"
                                      label="Vìlle"
                                      @blur="CopyTown()"
                                      autocomplete="editedItem.Customer.AddressSnowRemoval.TownID"
                                      hide-details
                                      :rules="requiredRules"
                                      required
                                    >
                                    </v-autocomplete>
                                  </v-flex>
                                  <v-flex xs12 sm12 md12>
                                    <v-text-field v-model="editedItem.Customer.AddressSnowRemoval.Province" label="Province" autocomplete="editedItem.Customer.AddressSnowRemoval.Province" hide-details :rules="requiredRules" required></v-text-field>
                                  </v-flex>
                                  <v-flex xs6 sm6 md6>
                                    <v-text-field v-model="editedItem.Customer.AddressSnowRemoval.AptNumber" label="Apt" autocomplete="editedItem.Customer.AddressSnowRemoval.AptNumber" hide-details :rules="requiredRules" required></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                        <v-flex d-flex xs6 sm6 md6>
                          <v-card>
                            <v-card-title style="padding:0px;">
                              <h5>Adresse postale</h5>
                            </v-card-title>
                            <v-card-text style="padding:0px;">
                              <v-container fluid grid-list-md style="padding:0px;">
                                <v-layout row wrap>
                                  <v-flex xs12 sm12 md12>
                                    <v-text-field v-model="editedItem.Customer.AddressPostal.DoorNumber" label="Numéro porte" autocomplete="editedItem.Customer.AddressPostal.DoorNumber" hide-details :rules="requiredRules" required></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm12 md12>
                                    <v-text-field v-model="editedItem.Customer.AddressPostal.Street" label="Adresse" autocomplete="editedItem.Customer.AddressPostal.Street" hide-details :rules="requiredRules" required></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm12 md12>
                                    <v-text-field v-model="editedItem.Customer.AddressPostal.Town" label="Ville" autocomplete="editedItem.Customer.AddressPostal.Town" hide-details :rules="requiredRules" required></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm12 md12>
                                    <v-text-field v-model="editedItem.Customer.AddressPostal.Province" label="Province" autocomplete="editedItem.Customer.AddressPostal.Province" hide-details :rules="requiredRules" required></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm12 md12>
                                    <v-text-field v-model="editedItem.Customer.AddressPostal.PostalCode" label="Code postal" autocomplete="editedItem.Customer.AddressPostal.PostalCode" hide-details :rules="requiredRules" required></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="close">Annuler</v-btn>
                <v-btn color="blue darken-1" flat @click.native="save">Sauvegarder</v-btn>
              </v-card-actions>
            </v-card>
        </v-dialog>
        <ModalConfirmation v-model="dialogEmailConfirmation" :Title="dialogEmailTitle" :Message="dialogEmailMessage" :CallBackYes="dialogEmailCallBackYes"></ModalConfirmation>
        <ModalPhoneNote v-model="dialogPhoneNote" :CustomerID="editedItem.Customer.ID" :CustomerName="editedItem.Customer.Name" :AddressSnowRemovalFullAddress="editedItem.Customer.AddressSnowRemoval.FullAddress"></ModalPhoneNote>
        <ModalContract v-model="dialogContract" :ID="editedItem.ID" :CustomerID="editedItem.ID" :CustomerName="editedItem.Customer.Name" :AddressSnowRemovalFullAddress="editedItem.Customer.AddressSnowRemoval.FullAddress" :CallBackSave="ContractCallBackSave"></ModalContract>
      </v-toolbar>
      <v-card>
        <v-card-title style="padding-top:25px;margin-bottom:50px;">
          <!-- Recherche -->
          <v-text-field v-model="searchFilters.Name" label="Nom" single-line hide-details></v-text-field>
          <div style="width:5px;"></div>
          <v-text-field v-model="searchFilters.CustomerNumber" label="Numéro client" single-line hide-details></v-text-field>
          <div style="width:5px;"></div>
          <v-text-field v-model="searchFilters.Email" label="Courriel" single-line hide-details></v-text-field>
          <div style="width:5px;"></div>
          <v-text-field v-model="searchFilters.PhoneNumber" label="Numéro téléphone/cellulaire" maxlength="10" return-masked-value mask="(###) ###-####" single-line hide-details></v-text-field>
          <div style="width:5px;"></div>
          <v-text-field v-model="searchFilters.Note" label="Note" maxlength="100" single-line hide-details></v-text-field>
          <div style="width:5px;"></div>
          <v-combobox
              :items="perioditems"
              v-model="searchFilters.Period"
              item-text="Name"
              item-value="ID"
              label="Période"
              hide-details
              required
          ></v-combobox>
          <div style="width:5px;"></div>
          <v-combobox
              :items="activeitems"
              v-model="searchFilters.Active"
              item-text="Name"
              item-value="ID"
              label="Actif"
              hide-details
              required
          ></v-combobox>
          <div style="width:5px;"></div>
          <v-text-field v-model="searchFilters.DoorNumber" label="No Porte" single-line hide-details></v-text-field>
          <div style="width:5px;"></div>
          <v-combobox
              :items="streetitems"
              v-model="searchFilters.Street"
              item-text="Name"
              item-value="ID"
              label="Rue"
              hide-details
              required
          ></v-combobox>
          <v-btn style="margin-top:20px;" color="primary" dark class="mb-2" @click="searchCustomers()">
            <v-icon>search</v-icon>
          </v-btn>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="items"
          :pagination.sync="pagination"
          :loading="loading"
          loading-text="En chargement..."
          hide-actions
          class="elevation-1"
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"

                :class="[
                'column sortable',
                pagination.descending ? 'desc' : 'asc',
                header.value === pagination.sortBy ? 'active' : '',
                header.align ? 'text-xs-' + header.align : ''
                ]"
                @click="changeSort(header.value)"
              >
                <v-icon small>arrow_upward</v-icon>
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ props.item.Customer.AddressSnowRemoval.AddressCustomerNumber }}</td>
            <td class="text-xs-left">{{ props.item.Period.Name }}</td>
            <td class="text-xs-left">{{ props.item.Customer.Name }}</td>
            <td class="text-xs-left">{{ props.item.Customer.AddressSnowRemoval.FullAddress }}</td>
            <td class="text-xs-left">{{ props.item.Customer.PhoneNumber }}</td>
            <td class="text-xs-left">{{ props.item.Customer.CellNumber }}</td>
            <td class="text-xs-left">{{ props.item.Customer.Email }}</td>
            <td class="text-xs-left">{{ props.item.Customer.Note }}</td>
            <td class="text-xs-left">{{ props.item.Customer.PrivateNote }}</td>
            <td class="justify-center layout px-0">
              <!-- perm_identity -->
              <v-icon medium class="mr-2" @click="editItem(props.item)">account_box</v-icon>
              <v-icon medium class="mr-2" @click="editContractItem(props.item)">assignment</v-icon>


              <v-icon medium class="mr-2" @click="editCustomerPhoneNote(props.item)" v-if="props.item.Customer.CustomerPhoneNotes.length <= 0">local_phone</v-icon>
              <v-icon medium class="mr-2" @click="editCustomerPhoneNote(props.item)" style="color:red;" v-if="props.item.Customer.CustomerPhoneNotes.length > 0">local_phone</v-icon>

              <v-icon medium class="mr-2" @click="printItem(props.item)">print</v-icon>

              <v-icon medium class="mr-2" v-if="props.item.Customer.Email" @click="emailItem(props.item)">email</v-icon>
              <v-icon medium class="mr-2" style="color: rgba(0,0,0,0.14) !important;cursor:default;" v-if="!props.item.Customer.Email">email</v-icon>
              <!-- <v-icon
                small
                @click="deleteItem(props.item)"
              >
                delete
              </v-icon> -->
            </td>
          </template>
          <template slot="no-data">
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
          <!-- <v-pagination v-model="pagination.page" :length="pages"></v-pagination> -->
          <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
        </div>
      </v-card>
      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :timeout="snackbar.timeout"
        :top="snackbar.top"
        :right="snackbar.right"
      >
        {{snackbar.text}}
      </v-snackbar>
    </div>
  </templateAdminComponent>
</template>

<script>
import auth from '@/auth'
import TemplateAdminComponent from '@/components/TemplateAdmin.vue'
import ModalConfirmation from '@/components/ModalConfirmation.vue'
import ModalPhoneNote from '@/components/ModalPhoneNote.vue'
import ModalContract from '@/components/ModalContract.vue'
import APICustomer from '@/api/customer'
import APIContract from '@/api/contract'
import APIStreet from '@/api/street'
import APITown from '@/api/town'
import APINoteType from '@/api/notetype'
import APIReport from '@/api/report'
import APIPeriod from '@/api/period'
const APIService = new APICustomer()
const APIContractService = new APIContract()
const APIStreetService = new APIStreet()
const APITownService = new APITown()
const APINoteTypeService = new APINoteType()
const APIReportService = new APIReport()
const APIPeriodService = new APIPeriod()
var axios = require('axios')

export default {
  components:
  {
    TemplateAdminComponent,
    ModalConfirmation,
    ModalPhoneNote,
    ModalContract
  },

  mounted() {
    //$('#date').datepicker()
    //$('#date').hide();
  },

  data() {
    //alert("data");
    //APIService.getBooks();
    return {
        dialog: false,
        dialogContract: false,
        dialogPhoneNote: false,
        loading: false,

        dialogEmailConfirmation: false,
        dialogEmailTitle: "Envoi de courriel",
        dialogEmailMessage: "",

        messageConfirmation: "Êtes-vous sûr de vouloir envoyer un courriel à {EMAIL} ?",
        messageConfirmed: "Le courriel a été envoyé avec succes à {EMAIL}",

        snackbar: {
          show: false,
          timeout: 5000,
          color: 'success',
          text: '',
          templatetext: '',
          top: true,
          right: true
        },

        pagination: {
          sortBy: 'Customer.AddressSnowRemoval.AddressCustomerNumber',
          page: 1,
          // total: 0,
          // perPage: 10,
          // visible: 10
          rowsPerPage: 10
        },
        headers : [
          { text: 'N° client', value: 'Customer.AddressSnowRemoval.AddressCustomerNumber', align: 'left' },
          { text: 'Période', value: 'Period.Name', align: 'left' },
          { text: 'Nom', value: 'Customer.Name', align: 'left' },
          { text: 'Adresse à déneiger', value: 'Customer.AddressSnowRemoval.FullAddress', align: 'left' },
          { text: '# Tél.', value: 'Customer.PhoneNumber', align: 'left' },
          { text: '# Cell.', value: 'Customer.CellNumber', align: 'left' },
          { text: 'Courriel', value: 'Customer.Email' , align: 'left' },
          { text: 'Note', value: 'Customer.Note' , align: 'left' },
          { text: 'Note privée', value: 'Customer.PrivateNote' , align: 'left' },
          { text: 'Actions', value: 'Actions', align: 'center', sortable: false }
        ],
        valid: false,
        requiredRules: [
          (v) => !!v || 'Field is required.',
        ],
        nameRules: [
          (v) => !!v || 'Name is required.',
          (v) => v && v.length <= 100 || 'Name must be less than 100 characters'
        ],
        items: [],
        townitems: [],
        streetitems: [],
        perioditemAll: [{ID: 0, Name: "Toutes", IsActive: false}],
        perioditems: [],
        activeitems: [{ID:1, Name:'Tous'}, {ID:2, Name:'Oui'}, {ID:3, Name:'Non'}],
        notetypes: [],
        streetName: '',
        townName: '',
        editedIndex: -1,
        editedItem: {
          ID: 0,
          Customer: {
            ID: 0,
            Name: '',
            PhoneNumber: '',
            CellNumber: '',
            Email: '',
            IsActive: true,
            ContractID: 0,
            AddressPostal : {},
            AddressSnowRemoval : { FullAddress: "" },
            CustomerNoteTypes : []
          }
        },
        defaultItem: {
          ID: 0,
          Customer: {
            ID: 0,
            Name: '',
            PhoneNumber: '',
            CellNumber: '',
            Email: '',
            IsActive: true,
            ContractID: 0,
            AddressPostal : {},
            AddressSnowRemoval : { FullAddress: "" },
            CustomerNoteTypes : []
          }
        },
        defaultAddressPostal : { Street: "", Town: "", Province: "(Qué)" },
        defaultAddressSnowRemoval : { FullAddress: "", DoorNumber:"", Address:"", Street:{}, Town:{}, AptNumber: "000", Province: "(Qué)" },
        searchFilters: {}
    }
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nouveau client' : 'Modification du client'
    },

    pages () {
      if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null)
        return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    items () {
      this.$nextTick(() => {
        this.pagination.totalItems = this.items.length
      })
    },
    dialogContract () {
      if (!this.dialogContract) {
        this.$refs.form.resetValidation()
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }
    },
    dialogPhoneNote () {
      if (!this.dialogPhoneNote) {
        this.$refs.form.resetValidation()
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }
    }
  },

  created(){
    this.initialize()
    //alert("created");
  },

  methods: {
    isFieldRequired(v, fieldName){
      return !!v || '{{fieldName}} is required'
    },
    isUserAuthenticated() {
      return auth.isUserAuthenticated();
    },

    logout() {
      auth.logout()
    },

    // mounted(){
    //       // let token = localStorage.getItem('id_token');
    //       // if(token == null){
    //       //     this.$router.push('/');
    //       // }
    // }
    initialize () {
      this.searchFilters.Active = this.activeitems[1]

      APIPeriodService.getAll().then(response => {
        this.perioditems = response.data
        this.perioditems.unshift(this.perioditemAll[0])
        this.searchFilters.Period = this.perioditems.find((x) => x.IsActive)
      })

      APIStreetService.getAll().then(response => {
        this.streetitems = response.data
      })

      APITownService.getAll().then(response => {
        this.townitems = response.data
      })

      APINoteTypeService.getAll().then(response => {
        this.notetypes = response.data
      })
    },

    searchCustomers() {
      this.loading = true
      var customers = APIContractService.search(this.searchFilters).then(response =>  {
          //debugger
          this.items = response.data
          this.loading = false
        }
      )
    },

    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    async printItem (item) {
      this.$router.open({name: 'AdminContract', params: {ID : item.ID}})
    },

    async emailItem (item) {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogEmailMessage = this.messageConfirmation.replace("{EMAIL}", this.editedItem.Customer.Email)
      this.dialogEmailConfirmation = true
    },

    dialogEmailCallBackYes() {
      this.dialogEmailConfirmation = false
      APIContractService.sendContractByEmail(this.editedItem.ID).then(response => {
        this.snackbar.text = this.messageConfirmed.replace("{EMAIL}", this.editedItem.Customer.Email)
        this.snackbar.show = true
      })
    },

    createItem () {
      this.$refs.form.resetValidation()
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedItem.Customer.AddressPostal = Object.assign({}, this.defaultAddressPostal)
      this.editedItem.Customer.AddressSnowRemoval = Object.assign({}, this.defaultAddressSnowRemoval)
      this.editedIndex = -1
      //debugger
      this.editedItem.Customer.CustomerNoteTypes = []
      for(var i = 0; i < this.notetypes.length; i++) {
        this.editedItem.Customer.CustomerNoteTypes.push({NoteType:this.notetypes[i], IsActive: true})
      }

      this.dialog = true
    },

    editItem (item) {
      //debugger
      this.$refs.form.resetValidation()
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)

      if (this.editedItem.Customer.CustomerNoteTypes.length == 0) {
        for(var i = 0; i < this.notetypes.length; i++) {
          this.editedItem.Customer.CustomerNoteTypes.push({NoteType:this.notetypes[i], IsActive: true})
        }
      }

      this.dialog = true
      this.dialogPhoneNote = false
      this.dialogContract = false
    },

    editContractItem (item) {
      //debugger
      this.$refs.form.resetValidation()
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = false
      this.dialogPhoneNote = false
      this.dialogContract = true
    },

    editCustomerPhoneNote(item) {
      //debugger
      this.$refs.form.resetValidation()
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = false
      this.dialogPhoneNote = true
      this.dialogContract = false
    },

    deleteItem (item) {
      const index = this.items.indexOf(item)
      if (confirm('Êtes-vous certain de vouloir supprimer cet item ?'))
      {
        APIService.delete(item).then(response => {
          if(response.data)
            this.items.splice(index, 1);
        });
      }
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedItem.AddressPostal = Object.assign({}, this.defaultAddressPostal)
        this.editedItem.AddressSnowRemoval = Object.assign({}, this.defaultAddressSnowRemoval)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.$refs.form.validate()) {
        var self = this
        if (this.editedIndex > -1) {
          //UPDATE
          APIService.update(this.editedItem.Customer).then(response => {
            this.close()
            this.searchCustomers()
          });
        } else {
          //CREATE
          APIService.create(this.editedItem.Customer).then(response => {
            this.searchFilters.Name = response.data.Customer.Name
            this.close()
            this.searchCustomers()
          });
        }
      }
    },

    ContractCallBackSave(contract) {
      //debugger
      this.items[this.editedIndex].ID = contract.ID
      //alert("callback!")
    },

    CopyDoorNumber() {
      if(!this.editedItem.Customer.AddressSnowRemoval.Address) {
        this.editedItem.Customer.AddressSnowRemoval.Address = this.editedItem.Customer.AddressSnowRemoval.DoorNumber
      }
      if (!this.editedItem.Customer.AddressPostal.DoorNumber) {
        this.editedItem.Customer.AddressPostal.DoorNumber = this.editedItem.Customer.AddressSnowRemoval.DoorNumber
      }
    },
    CopyStreet() {
      //debugger
      if (!this.editedItem.Customer.AddressPostal.Street)
        this.editedItem.Customer.AddressPostal.Street = this.streetName
    },
    CopyTown() {
      //debugger
      if (!this.editedItem.Customer.AddressPostal.Town)
        this.editedItem.Customer.AddressPostal.Town = this.townName
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/Clients.vue